import { render, staticRenderFns } from "./MatchOverview.vue?vue&type=template&id=0e1d9c69&scoped=true&"
import script from "./MatchOverview.vue?vue&type=script&lang=ts&"
export * from "./MatchOverview.vue?vue&type=script&lang=ts&"
import style0 from "./MatchOverview.vue?vue&type=style&index=0&id=0e1d9c69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1d9c69",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
